import { render, staticRenderFns } from "./ZonePriceTable.vue?vue&type=template&id=9b4eca82&scoped=true"
import script from "./ZonePriceTable.vue?vue&type=script&lang=js"
export * from "./ZonePriceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4eca82",
  null
  
)

export default component.exports